import { Box, TextField, Typography, Stack, Backdrop, CircularProgress, TableCell, IconButton, ButtonGroup, Button } from "@mui/material";
import Header from "../Components/layout/Header";
import xlsx from "json-as-xlsx";
import { useState, useEffect, useContext } from "react";
import { API } from "../conf";
import SorTableCheckable from "../Components/ui/sortable-checkable";
import { Edit, InfoOutlined } from "@mui/icons-material";
import { Context } from "../App";
import moment from "moment";
import { COMPTES_DE_CHARGES } from "../asset/variables";

export default function EBPexport(journal) {
  const { updateConnect, exercice } = useContext(Context)

  const organisation = JSON.parse(sessionStorage.getItem('eglise'))
  const [load, setLoad] = useState(true)
  const [selected, setSelected] = useState('')
  const [clotures, setClotures] = useState([])
  const [eglises, setEglises] = useState([])
  const [cloture, setCloture] = useState()
  const [open, setOpen] = useState(false)
  const [action, setAction] = useState('')
  const [mois, setMois] = useState('')
  const [dispoMonths, setDispoMonths] = useState([])
  const [search, setSearch] = useState('')

  const [petiteCaisses, setPetiteCaisses] = useState([])

  const table = [
    {header: "Église", sortable: true, sortBy:(el)=>el.eglise.nom.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize'}}>{row.eglise.nom}</TableCell>},
    {header: "Date de clôture", sortable: true, sortBy:(el)=>new Date(el.date).getTime(), row: (row, index)=><TableCell align="center" key={index}>{moment(row.date).format('LL')}</TableCell>},
    {header: "Dons", sortable: true, sortBy:(el)=>el.dons.length, row: (row, index)=><TableCell key={index} sx={{maxWidth:'70px', textAlign:'center'}}>{row.dons.length}</TableCell>},
    {header: "Dépenses", sortable: true, sortBy:(el)=>el.depenses.length, row: (row, index)=><TableCell key={index} sx={{maxWidth:'70px', textAlign:'center'}}>{row.depenses.length}</TableCell>},
    {header: "Versements", sortable: true, sortBy:(el)=>el.versements.length, row: (row, index)=><TableCell key={index} sx={{maxWidth:'70px', textAlign:'center'}}>{row.versements.length}</TableCell>},
  ]

  function normalize(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
  }

  function get_searchable(item) {
    if(!item) return ''
    const eglise = item.eglise
    if(!eglise) return ''
    return eglise.nom+' '+eglise.adresse1+' '+eglise.adresse2+' '+eglise.zip_code+' '+eglise.commune
  }

  function manage_dialog(status, action) {
    setOpen(status); setAction(action)
    if (!status) {
      setCloture()
    } 
  }

  function exportRapport(content) {
    let data = [
      {
        sheet: "RAPPORT",
        columns: [
          { label: "Journal", value: () => 750 },
          { label: "Date", value: row => moment(row.date).endOf('month').format('DD/MM/YYYY') },
          { label: "Pièce", value: row => row.pièce },
          { label: "Numéro de compte", value: row => row.num_compte },
          { label: "Libellé", value: row => row.libelle },
          { label: "Débit", value: row => row.debit },
          { label: "Crédit", value: row => row.credit },
          { label: "Poste analytique", value: row => row.poste_analytique },
        ],
        content: content,
      },
    ];
  
    let settings = {
      fileName: "RAPPORT_"+new Date(mois).toLocaleString('fr-FR', { month: 'long' }),
    };
  
    xlsx(data, settings);
  }

  function exportDepenses(content) {
    let data = [
      {
        sheet: "JOURNAL DE DÉPENSES",
        columns: [
          { label: "Journal", value: row => row.journal || '' },
          { label: "Date", value: row => moment.utc(row.date).format('DD/MM/YYYY') },
          { label: "N° de facture", value: row => row.num_facture || '' },
          { label: "Numéro de compte", value: row => row.num_compte || '' },
          { label: "Libellé", value: row => row.libelle || '' },
          { label: "Débit", value: row => row.debit || '' },
          { label: "Crédit", value: row => row.credit || '' },
          { label: "mode de règlement", value: row => row.mode_reglement || '' },
          { label: "Poste analytique", value: row => row.poste_analytique || '' },
        ],
        content: content,
      },
    ];
  
    let settings = {
      fileName: "JOURNAL_DEPENSES_"+new Date(mois).toLocaleString('fr-FR', { month: 'long' }),
    };
  
    xlsx(data, settings);
  }

  function getChurchRapport(dons){
    const dime = Math.round(dons.reduce((acc, don) => acc + (don.dime || 0), 0)*100)/100
    
    const offG = Math.round(dons.reduce((acc, don) => acc + (don.offrande_globale || 0), 0)*100)/100
    console.log(dons.filter(don=>don.offrande_spe_feam.some(off=> off.compte === null )))
    const offSfed = Math.round(dons.reduce((acc, don) => acc + (don.offrande_spe_feam
      ?.filter(off=>['interne', 'autre'].includes(off.compte?.type)&&['secours adventiste', 'radio esperance'].every(libelle=>!normalize(off.compte?.libelle).includes(libelle)))
      .reduce((tt, off) => tt + (off.montant || 0), 0) || 0), 0)*100)/100
    
    const offSegl = Math.round(dons.reduce((acc, don) => acc + (don.offrande_spe_eglise?.reduce((tt, off) => tt + (off.montant || 0), 0) || 0), 0)*100)/100
    
    const offSAM = Math.round(dons.reduce((acc, don) => acc + (don.offrande_spe_feam
      ?.filter(off=>normalize(off.compte?.libelle||'').includes('secours adventiste'))
      .reduce((tt, off) => tt + (off.montant || 0), 0) || 0), 0)*100)/100
    
    const offRadio = Math.round(dons.reduce((acc, don) => acc + (don.offrande_spe_feam
      ?.filter(off=>normalize(off.compte?.libelle||'').includes('radio esperance'))
      .reduce((tt, off) => tt + (off.montant || 0), 0) || 0), 0)*100)/100

    const offOGEA = [...new Set(dons.map(don=>don.offrande_spe_feam?.filter(off=>normalize(off.compte?.libelle||'').includes('ogea')).map(off=>off.compte?.libelle+';'+off.compte?.num_compte)).flat())]
      .map(libelle=> ({libelle: libelle.split(';')[0], num_compte: libelle.split(';')[1], montant: dons.reduce((acc, don) => acc + (don.offrande_spe_feam
        ?.filter(off=>off.compte?.libelle===libelle)
        .reduce((tt, off) => tt + (off.montant || 0), 0) || 0), 0)
      }))

    const offAMAPLR_institutions = [...new Set(dons.map(don=>don.offrande_spe_feam?.filter(off=> normalize(off.compte?.libelle||'').includes('amaplr') ||
      (off.compte?.type==='institution' && ['ogea', 'secours adventiste', 'radio esperance'].every(libelle=>!normalize(off.compte?.libelle).includes(libelle))))
    .map(off=>off.compte?.libelle+';'+off.compte?.num_compte)).flat())]
      .map(libelle=> ({libelle: libelle.split(';')[0], num_compte: libelle.split(';')[1], montant: dons.reduce((acc, don) => acc + (don.offrande_spe_feam
        ?.filter(off=>off.compte?.libelle===libelle)
        .reduce((tt, off) => tt + (off.montant || 0), 0) || 0), 0)
      }))

    return({dime, offG, offSfed, offSegl, offSAM, offRadio, offOGEA, offAMAPLR_institutions})
  }

  async function getRapport() {
    setLoad(true)
    fetch(API.concat('/clotures/rapport'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
      },body: JSON.stringify({dons: clotures.filter(c=>selected.includes(c._id)).map(c=>c.dons).flat(), eglises: clotures.filter(c=>selected.includes(c._id)).map(c=>c.eglise.number), exercice})
    }).then(async response => {
      const token = response.headers.get('x-auth-token')
      if (response.status === 401) {
        sessionStorage.clear()
        updateConnect(false)
      } else {
        if (token && token !== sessionStorage.getItem('token') && token !== '') {
          sessionStorage.setItem('token', response.headers.get('x-auth-token'))
        }
        if (response.status === 200) {
          const {dons, eglises, petiteCaisses, liaisons_comptes} = await response.json()
          //traitement des données
          getChurchRapport(dons)
          const content = eglises.map(eglise => {
            const churchDons = dons.filter(don => don.eglise === eglise.number)
            const rapport = getChurchRapport(churchDons)
            
            return [
              {
                date: new Date(mois).setDate(1),
                num_compte: petiteCaisses.find(pc => pc.eglise === eglise.number)?.num_compte || '',
                libelle: `DIMES ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' })}`.toUpperCase(),
                debit: rapport.dime,
                credit: "",
                poste_analytique: eglise.code_analytique || ''
              },
              { date: new Date(mois).setDate(1),
                num_compte: petiteCaisses.find(pc => pc.eglise === eglise.number)?.num_compte || '',
                libelle: `40% offrande globale ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                debit: Math.round((Number.EPSILON + rapport.offG * 0.4) * 100) / 100,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: petiteCaisses.find(pc => pc.eglise === eglise.number)?.num_compte || '',
                libelle: `Offrandes SP ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                debit: rapport.offSfed,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: petiteCaisses.find(pc => pc.eglise === eglise.number)?.num_compte || '',
                libelle: `60% offrande globale ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                debit: rapport.offG - Math.round((Number.EPSILON + rapport.offG * 0.4) * 100) / 100,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: petiteCaisses.find(pc => pc.eglise === eglise.number)?.num_compte || '',
                libelle: `Offrandes spécifiées ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                debit: rapport.offSegl,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: petiteCaisses.find(pc => pc.eglise === eglise.number)?.num_compte || '',
                libelle: `Secours adventiste ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                debit: rapport.offSAM,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: petiteCaisses.find(pc => pc.eglise === eglise.number)?.num_compte || '',
                libelle: `ESPERANCE FM ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                debit: rapport.offRadio,
                poste_analytique: eglise.code_analytique || ''
              },
              ...rapport.offOGEA.map(off => ({
                date: new Date(mois).setDate(1),
                num_compte: petiteCaisses.find(pc => pc.eglise === eglise.number)?.num_compte || '',
                libelle: `ECOLE :${off.libelle.toUpperCase()} ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                debit: off.montant,
                poste_analytique: eglise.code_analytique || ''
              })),
              ...rapport.offAMAPLR_institutions.map(off => ({
                date: new Date(mois).setDate(1),
                num_compte: petiteCaisses.find(pc => pc.eglise === eglise.number)?.num_compte || '',
                libelle: `${off.libelle.toUpperCase()} ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                debit: off.montant,
                poste_analytique: eglise.code_analytique || ''
              })),
              //185 église
              {
                date: new Date(mois).setDate(1),
                num_compte: liaisons_comptes.find(lc => lc.eglise === eglise.number)?.num_compte || '',
                libelle: `DIMES ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' })}`.toUpperCase(),
                debit: rapport.dime,
                credit: "",
                poste_analytique: eglise.code_analytique || ''
              },
              { date: new Date(mois).setDate(1),
                num_compte: liaisons_comptes.find(lc => lc.eglise === eglise.number)?.num_compte || '',
                libelle: `40% offrande globale ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                debit: Math.round((Number.EPSILON + rapport.offG * 0.4) * 100) / 100,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: liaisons_comptes.find(lc => lc.eglise === eglise.number)?.num_compte || '',
                libelle: `Offrandes SP ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                debit: rapport.offSfed,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: liaisons_comptes.find(lc => lc.eglise === eglise.number)?.num_compte || '',
                libelle: `Secours adventiste ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                debit: rapport.offSAM,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: liaisons_comptes.find(lc => lc.eglise === eglise.number)?.num_compte || '',
                libelle: `ESPERANCE FM ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                debit: rapport.offRadio,
                poste_analytique: eglise.code_analytique || ''
              },
              ...rapport.offOGEA.map(off => ({
                date: new Date(mois).setDate(1),
                num_compte: liaisons_comptes.find(lc => lc.eglise === eglise.number)?.num_compte || '',
                libelle: `ECOLE :${off.libelle.toUpperCase()} ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                debit: off.montant,
                poste_analytique: eglise.code_analytique || ''
              })),
              ...rapport.offAMAPLR_institutions.map(off => ({
                date: new Date(mois).setDate(1),
                num_compte: liaisons_comptes.find(lc => lc.eglise === eglise.number)?.num_compte || '',
                libelle: `${off.libelle.toUpperCase()} ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                debit: off.montant,
                poste_analytique: eglise.code_analytique || ''
              })),
              //185 FEAM
              {
                date: new Date(mois).setDate(1),
                num_compte: '1851000000',
                libelle: `DIMES ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' })}`.toUpperCase(),
                credit: rapport.dime,
                poste_analytique: eglise.code_analytique || ''
              },
              { date: new Date(mois).setDate(1),
                num_compte: '1851000000',
                libelle: `40% offrande globale ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                credit: Math.round((Number.EPSILON + rapport.offG * 0.4) * 100) / 100,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: '1851000000',
                libelle: `Offrandes SP ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                credit: rapport.offSfed,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: '1851000000',
                libelle: `Secours adventiste ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                credit: rapport.offSAM,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: '1851000000',
                libelle: `ESPERANCE FM ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                credit: rapport.offRadio,
                poste_analytique: eglise.code_analytique || ''
              },
              ...rapport.offOGEA.map(off => ({
                date: new Date(mois).setDate(1),
                num_compte: '1851000000',
                libelle: `ECOLE :${off.libelle.toUpperCase()} ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                credit: off.montant,
                poste_analytique: eglise.code_analytique || ''
              })),
              ...rapport.offAMAPLR_institutions.map(off => ({
                date: new Date(mois).setDate(1),
                num_compte: '1851000000',
                libelle: `${off.libelle.toUpperCase()} ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                credit: off.montant,
                poste_analytique: eglise.code_analytique || ''
              })),
              //708 & 467
              {
                date: new Date(mois).setDate(1),
                num_compte: '7080010000',
                libelle: `DIMES ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' })}`.toUpperCase(),
                credit: rapport.dime,
                poste_analytique: eglise.code_analytique || ''
              },
              { date: new Date(mois).setDate(1),
                num_compte: '7080130000',
                libelle: `40% offrande globale ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                credit: Math.round((Number.EPSILON + rapport.offG * 0.4) * 100) / 100,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: '7080080000',
                libelle: `Offrandes SP ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                credit: rapport.offSfed,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: '7080070000',
                libelle: `60% offrande globale ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                credit: rapport.offG - Math.round((Number.EPSILON + rapport.offG * 0.4) * 100) / 100,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: '7080072000',
                libelle: `Offrandes spécifiées ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                credit: rapport.offSegl,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: '4676000000',
                libelle: `Secours adventiste ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                credit: rapport.offSAM,
                poste_analytique: eglise.code_analytique || ''
              },
              {
                date: new Date(mois).setDate(1),
                num_compte: '4676070000',
                libelle: `ESPERANCE FM ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                credit: rapport.offRadio,
                poste_analytique: eglise.code_analytique || ''
              },
              ...rapport.offOGEA.map(off => ({
                date: new Date(mois).setDate(1),
                num_compte: off.num_compte || '',
                libelle: `ECOLE :${off.libelle.toUpperCase()} ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                credit: off.montant,
                poste_analytique: eglise.code_analytique || ''
              })),
              ...rapport.offAMAPLR_institutions.map(off => ({
                date: new Date(mois).setDate(1),
                num_compte: off.num_compte || '',
                libelle: `${off.libelle.toUpperCase()} ${eglise.nom} ${new Date(mois).toLocaleString('fr-FR', { month: 'long', year: 'numeric' }).toUpperCase()}`,
                credit: off.montant,
                poste_analytique: eglise.code_analytique || ''
              })),
            ].map(line => ({pièce: `${eglise.number}${exercice}${(mois.split('-')[1]).padStart(2, '0')}`, ...line}))
          }).flat().filter(line => line.debit > 0 || line.credit > 0).map(line => ({...line, libelle: line.libelle.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase()}))

          setEglises(eglises)
          setPetiteCaisses(petiteCaisses)
          exportRapport(content)
        }
      }
    })
    .catch(err => console.error(err))
    .finally(() => setLoad(false))
  }

  async function getDepensesJrnl() {
    setLoad(true)
    fetch(API.concat('/clotures/depenses_journal'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
      },body: JSON.stringify({depenses: clotures.filter(c=>selected.includes(c._id)).map(c=>c.depenses).flat(), eglises: clotures.filter(c=>selected.includes(c._id)).map(c=>c.eglise.number)})
    }).then(async response => {
      const token = response.headers.get('x-auth-token')
      if (response.status === 401) {
        sessionStorage.clear()
        updateConnect(false)
      } else {
        if (token && token !== sessionStorage.getItem('token') && token !== '') {
          sessionStorage.setItem('token', response.headers.get('x-auth-token'))
        }
        if (response.status === 200) {
          const {depenses, eglises, petiteCaisses, comptesBancaires} = await response.json()
          console.log(depenses)
          //traitement des données
          const content = depenses.map(depense => {
            const eglise = eglises.find(e => e.number === depense.eglise)
            const compteDeCharge = COMPTES_DE_CHARGES.find(c => c.libelle === depense.class)?.num_compte || ''
            const rows = Object.entries(depense.paymode).filter(([mode, info]) => info > 0 || info.length >0 || (typeof info === 'object'&& !Array.isArray(info))).map(([mode, info]) => [
              {
                journal: mode === 'especes' ? 'es' : 'BP',
                date: depense.date,
                num_facture: depense.num_facture || '',
                num_compte: compteDeCharge.startsWith('7') ? comptesBancaires.find(c => c.eglise === depense.eglise)?.num_compte || '' : compteDeCharge,
                libelle: `${eglise?.nom || ''} ${depense.fournisseur}, ${depense.libelle}`,
                debit: mode === 'especes' ? info : mode==='cheques' ? info.reduce((acc, chq) => acc + (chq.montant || 0), 0) : info.montant || 0,
                mode_reglement: mode === 'especes' ? 'espèce' : mode === 'cheques' ? 'chèque' : mode === 'virement' ? 'vse' : mode === 'prelevement' ? 'pse' : mode,
                poste_analytique: eglise?.code_analytique || ''
              },
              {
                journal: mode === 'especes' ? 'es' : 'BP',
                date: depense.date,
                num_facture: depense.num_facture || '',
                num_compte: compteDeCharge.startsWith('7') ? compteDeCharge : (mode === 'especes' ? petiteCaisses : comptesBancaires).find(c => c.eglise === depense.eglise)?.num_compte || '',
                libelle: `${eglise?.nom || ''} ${depense.fournisseur}, ${depense.libelle}`,
                credit: mode === 'especes' ? info : mode==='cheques' ? info.reduce((acc, chq) => acc + (chq.montant || 0), 0) : info.montant || 0,
                mode_reglement: mode === 'especes' ? 'espèce' : mode === 'cheques' ? 'chèque' : mode === 'virement' ? 'vse' : mode === 'prelevement' ? 'pse' : mode,
                poste_analytique: eglise?.code_analytique || ''
              }
            ])
            
            return rows
          }).flat(2)

          setEglises(eglises)
          setPetiteCaisses(petiteCaisses)
          exportDepenses(content)
        }
      }
    })
    .catch(err => console.error(err))
    .finally(() => setLoad(false))
  }

  useEffect(()=>{
    if(mois){
      setLoad(true)
      setSelected([])

      fetch(API.concat(`/clotures/eglises/by`), {
        method:'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }, body: JSON.stringify(
          {
            isMonth: true, exercice, $and : [ {date: {
              $gte: new Date(exercice,Number(mois.split('-')[1])-1,1)
            }}, {date: {
              $lt: new Date((Number(mois.split('-')[0])=== 12 ? exercice+1 : exercice), (Number(mois.split('-')[0])=== 12 ? 0 : Number(mois.split('-')[1])),1)
            }}]
            
          }
        )
      }).then(async response=>{
        const token = response.headers.get('x-auth-token')
        if(response.status === 401) {
          sessionStorage.clear()
          updateConnect(false)
        }else {
          if (token && token !== sessionStorage.getItem('token') && token !== '') {
            sessionStorage.setItem('token', response.headers.get('x-auth-token'))
          }
          if (response.status === 200) {
            const json = await response.json();
            setClotures(json)
          } else {
            setClotures([])
            console.error('Erreur lors du chargement des clôtures', response.statusText)
            alert('Erreur lors du chargement des données')
          }
        }
      }).finally(()=> setLoad(false))
    }
  }, [mois])

  useEffect(()=>{
    fetch(API.concat(`/clotures/distinct_dates`), {
      method:'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem('token')
      }, body: JSON.stringify({exercice})
    }).then(async response=>{
      const token = response.headers.get('x-auth-token')
      if(response.status === 401) {
        sessionStorage.clear()
        updateConnect(false)
      }else {
        if (token && token !== sessionStorage.getItem('token') && token !== '') {
          sessionStorage.setItem('token', response.headers.get('x-auth-token'))
        }
        if (response.status === 200) {
          const json = await response.json() 
          const dates = [...new Set(json.map(d => {
            const dateObj = new Date(d);
            return `${dateObj.getFullYear()}-${dateObj.getMonth() + 1}`;
          }))];
          setDispoMonths(dates.sort((a, b) => new Date(b) - new Date(a)))
        }
      }
    }).finally(()=> setLoad(false))
  }, [])

  return(
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <Header/>
      <Typography variant="h4" align="center" mt={3}>Module d'export pour EBP</Typography>

      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', my: 2, px: 3 }}>
        <TextField select label="Mois" size="small" SelectProps={{ native: true}} InputLabelProps={{ shrink: true }} sx={{ width: 'auto', minWidth: 150 }}
        value={mois} onChange={(e) => setMois(e.target.value)}>
          <option disabled value="">Sélectionner un mois</option>
          {dispoMonths.map((month, i) => (
            <option key={i} value={month}>{moment.utc(month).locale('fr-FR').format('MMMM YYYY')}</option>
          ))}
        </TextField>

        <ButtonGroup variant="text" sx={{ "& .MuiButton-root": { color: "#4682B4" } }} disabled={selected.length===0 || !mois}>
          <Button onClick={()=>getRapport()}>Exporter le rapport</Button>
          <Button onClick={()=>getDepensesJrnl()}>Exporter le journal de dépenses</Button>
        </ButtonGroup>
      </Box>

      <TextField label="Rechercher une église" size="small" sx={{ mx:3, alignSelf:'center', width:'60%', minWidth: '300px' }} value={search} onChange={(e) => setSearch(e.target.value)} />

      <div style={{marginInline:'30px'}}><SorTableCheckable data={clotures.filter(log=> normalize(get_searchable(log)).includes(normalize(search)))} selectItems={selected} setItems={setSelected} table={table} rowsPerPage={50} rowsPerPageOptions={[25, 50, 100, 300]}/></div>

      <Backdrop open={load}><CircularProgress /></Backdrop>
    </Box>
  )
}